<template>
    <div class="cloud-no-verify">
        <div :class="[ 'verify-content' ]">
            <!-- main content -->
            <div>
                <div class="verify-header">
                    <div class="verify-header-bg">
                        <h1>{{ $t('cloud.noVerify.title') }}</h1>
                        <p class="sub-title">{{ $t('cloud.noVerify.subTitle') }}</p>
                    </div>
                </div>
                <!-- buy content -->
                <div class="subscription-content js-subscription-content">
                    <h3>{{ $t('cloud.noVerify.subscriptionTitle') }}</h3>
                    <p v-if="config.platform !== 'app'">
                        <span class="change-email-des">{{ $t('cloud.noVerify.subscriptionSubTitle') }}</span>
                        <reo-tip v-if="!FEATURE( 'cloud.email_check' )">
                            <p class="email-tip" v-html="$t('cloud.noVerify.emailTip')"></p>
                        </reo-tip>
                    </p>
                    <p :class="['verify-status', verified ? 'verified' : 'unVerified']" v-if="config.platform !== 'app'">
                        {{ FEATURE( 'cloud.email_check' ) ? phone : email }}
                        <span v-if="verified" class="verify-status-inner">
                            <span class="icon-icon_have"></span>
                            <span>{{ $t('cloud.noVerify.verified') }}</span>
                        </span>
                        <span v-else class="verify-status-inner">
                            <span class="icon-icon_wrong"></span>
                            <span>{{ $t('cloud.noVerify.unVerified') }}</span>
                        </span>
                    </p>
                    <p v-if="!verified && config.platform !== 'app'">
                        <span class="verify-button" @click="verify">{{ $t('cloud.noVerify.verifyButton') }}</span>{{ $t('cloud.noVerify.verifyButtonEnd') }}
                    </p>
                    <p class="verify-suc" v-if="verifySuc"><span class="icon-icon_have"></span>{{ $t('cloud.noVerify.verifySuc') }}</p>
                    <countrySelectSpinner v-if="!FEATURE('cloud.country_select')" @countrySelect="selectedCountry=$event"></countrySelectSpinner>
                    <productSelectSpinner @productSelect="selectedProduct=$event"></productSelectSpinner>
                    <div class="choose-plan">
                        <p
                        class="notice-for-free"
                        v-html="planNoticeText"
                        v-if="cloudConfig.planNotice && cloudConfig.planNotice.show">
                        </p>
                        <p class="choose-plan-title">{{ $t('cloud.noVerify.choosePlan') }}</p>
                        <plan-item
                        v-for="(plan, index) in planList"
                        :key="index"
                        :plan="plan"
                        :selectedId="planId"
                        :activeItem="activeItem"
                        :index="index"
                        :disabledPlan="disabledPlan"
                        @changeActive="changeActive"
                        @selectProduct="selectProduct"></plan-item>
                        <div class="plan-statement">
                            <reo-checkbox v-model="agree" size="small" class="plan-statement-check"></reo-checkbox>
                            <p v-html="$t('cloud.noVerify.statement', {
                                conditions: getOfficialUrl( config.conditions ),
                                privacy: getOfficialUrl( config.privacy )
                            })">
                            </p>
                        </div>
                    </div>
                    <button
                    ga-label="Subscribe"
                    class="ui-button primary-button short-button"
                    :disabled="!agree"
                    style="padding-left: 0.45rem;padding-right: 0.45rem;"
                    @click="subscribe">{{$t('cloud.noVerify.subscribe')}}</button>
                </div>
                <!--END  buy content -->
            </div>
            <!-- END main content -->
        </div>
        <reo-dialog
        v-if="showSubDialog"
        class="video-quantity-confirm-dialog"
        :title="$t('videoQuantityConfirm.title')"
        :labelOfConfirm="$t('videoQuantityConfirm.confirm')"
        :labelOfCancel="$t('videoQuantityConfirm.cancel')"
        @confirm="goCheckout"
        @cancel="showSubDialog = false">
            <div slot="top">
                <video-quantity-confirm
                :current-quantity="currentVideoQuantity"
                :plan-quantity="planVideoQuantity"
                :plan-title="planTitle"></video-quantity-confirm>
            </div>
        </reo-dialog>
    </div>
</template>

<script>
import ReoInput from '@/basic/Input';
import countrySelectSpinner from '@/components/countrySelectSpinner';
import productSelectSpinner from '@/components/productSelectSpinner';
import { verify, getDeviceList } from '@/api/cloud';
import { getProducts } from '@/api/cart';
import ReoCheckbox from '@/basic/Checkbox';
import ReoTip from '@/basic/Tip';
import { config } from 'CONFIG';
import { unfoldError } from '@/common/js/notice';
import PlanItem from './PlanItem';
import user from '@/api/user';
import router from '@/router';
import { buyProduct, orderedProductInfo } from '@/api/plan';
import {plan as planStatus} from '@/config/status';
import ReoDialog from '@/basic/Dialog';
import videoQuantityConfirm from '@/components/videoQuantityConfirm';
import { getCloudConfig, listToString } from '@/api/s3Config';
import store from '@/store';

export default {

    components: {

        ReoInput,
        ReoCheckbox,
        ReoTip,
        PlanItem,
        ReoDialog,
        videoQuantityConfirm,
        countrySelectSpinner,
        productSelectSpinner

    },
    data () {

        return {

            planList: [],
            email: this.$store.state.user.user.email.address,
            phone: '+' + this.$store.state.user.user.mobilePhone.number,
            verifySuc: false,
            agree: false,
            config,
            planId: Number( this.$route.query.plan_id ) || 0,
            betaStock: 0,
            activeItem: 100,
            disabledPlan: [],
            sub: null,
            showSubDialog: false,
            planVideoQuantity: 0,
            currentVideoQuantity: 0,
            planTitle: '',
            cloudConfig: {},
            selectedCountry: '',
            selectedProduct: []

        };

    },
    computed: {

        verified () {

            if ( this.FEATURE( 'cloud.email_check' )) {

                return this.$store.state.user.user.mobilePhone.status === 'verified';
            
            } else {

                return this.$store.state.user.user.email.status === 'verified';
            
            }

        },
        planNoticeText () {

            if ( !this.cloudConfig.planNotice || !this.cloudConfig.planNotice.show || !this.cloudConfig.planNotice.text ) {

                return '';

            } else {

                let lang = store.state.lang.lang;
                return this.cloudConfig.planNotice.text[lang] || '';

            }

        },
        deviceList () {

            let deviceList = this.cloudConfig.productSupported;
            if ( !deviceList || !deviceList.length ) {

                return '';

            }
            return listToString( deviceList.map( item => item.product ));

        },
        deviceWithLink () {

            let deviceList = this.cloudConfig.productSupported;
            if ( !deviceList || !deviceList.length ) {

                return '';

            }
            let deviceListWithLink = deviceList.map(
                device => `<a href="${this.getOfficialUrl( device.link )}" target="_blank">${device.product}</a>`
            );
            return listToString( deviceListWithLink );

        },
        countrySupported () {

            let countrySupported = this.cloudConfig.countrySupported;
            if ( !countrySupported ) return '';
            let locale = store.state.lang.lang;
            let texts = countrySupported[ locale ];
            if ( !texts || !texts.length ) {

                return '';

            }
            return listToString( texts );

        }
    },
    async created () {

        let sub = await orderedProductInfo();
        this.sub = sub;
        this.getProducts();
        let cloudConfig = await getCloudConfig();
        this.cloudConfig = cloudConfig;

    },
    destroyed () {

        clearTimeout();

    },
    methods: {

        async getProducts () {

            try {

                let planList = await getProducts();
                this.planList = planList;
                let disabledPlan = [];
                for ( let series of planList ) {

                    for ( let product of series.products ) {

                        if ( this.$store.state.user.showBeta ) {

                            if ( product.title !== config.beta_plan_title ) {

                                disabledPlan.push( product.id );

                            } else {

                                this.betaStock = product.stockQuantity;
                                if (( this.sub && this.sub.plan.title === config.beta_plan_title ) || product.stockQuantity === 0 ) {

                                    disabledPlan.push( product.id );

                                }

                            }

                        } else if ( product.status !== planStatus.ENABLED ) {

                            disabledPlan.push( product.id );

                        }

                    }

                }
                this.disabledPlan = disabledPlan;

            } catch ( err ) {

                console.error( err );
                unfoldError( 'errors.server_error' );

            }

        },

        async verify () {

            try {

                await verify( this.email );
                this.verifySuc = true;
                this.refresh();

            } catch ( err ) {

                this.verifySuc = false;
                unfoldError( 'errors.verify_email_detected' );
                console.error( err );

            }

        },

        async subscribe () {

            if (( !this.FEATURE( 'cloud.country_select' ) && !this.selectedCountry ) || !this.selectedProduct.length ) {

                unfoldError( 'errors.field_required' );
                window.scrollTo( 0, $( '.js-subscription-content' ).offset().top );
                return;

            }

            await user.getUserInfo();

            if ( !this.FEATURE( 'cloud.email_check' ) && !this.verified ) {

                unfoldError( 'cloud.noVerify.notice_verify_email' );

            } else if ( !this.planId ) {

                unfoldError( 'cloud.noVerify.notice_plan' );

            } else if ( !this.agree ) {

                unfoldError( 'cloud.noVerify.notice_agree' );

            } else {

                if ( this.$store.state.user.showBeta ) {

                    try {

                        await buyProduct(
                            [
                                {
                                    product: this.planId,
                                    quantity: 1
                                }
                            ]
                        );
                        router.push({

                            path: '/user/complete/',
                            query: {mode: 'subscribe'}

                        });

                    } catch ( err ) {

                        unfoldError( 'errors.server_error' );

                    }

                } else {

                    let userDevice = await getDeviceList();
                    let userDeviceQuantity = userDevice.filter( device => device.status === 'associated' && !device.sharedInfo ).length;
                    if ( userDeviceQuantity > this.planVideoQuantity ) {

                        this.currentVideoQuantity = userDeviceQuantity;
                        this.showSubDialog = true;

                    } else {

                        this.goCheckout();

                    }

                }

            }

        },

        goCheckout () {

            router.push({

                path: '/checkout/',
                query: {

                    plan_id: this.planId

                }

            });

        },

        refresh () {

            setTimeout(() => {

                location.replace( location.href );

            }, 600 * 1000 );

        },

        selectProduct ( plan ) {

            this.planId = plan.id;
            this.planVideoQuantity = plan.metadata['cloud_storage.max_device_quantity'];
            this.planTitle = plan.title;

        },

        changeActive ( index ) {

            this.activeItem = index;

        }

    }

};
</script>

<style lang="less">

    @linear-background: linear-gradient( 90deg , @theme-linear-gradient-start , @theme-linear-gradient-end );

    .cloud-no-verify{
        background-color: #EBF5FF;
        text-align: center;
        position: relative;
        .verify-header{
            max-width: 1270px;
            margin: auto;
            text-align: left;
            color: #fff;
            .verify-header-bg {
                padding-bottom: 1.2rem;
            }
        }
        .verify-content{
            background-image: url('~IMAGE/cloud/cloud-no-verify-bg.png');
            background-size: contain;
            background-position: top center;
            background-repeat: no-repeat;
            padding: 1.2rem 0 1rem;
            box-sizing: border-box;
            position: relative;
        }
        .change-email-des{
            font-weight: 500;
        }
        .verify-content .sub-title{
            font-weight: 500;
            font-size: 0.2rem;
        }
        .verify-content h1{
            font-size: 0.45rem;
            margin-bottom: 0.15rem;
        }
        .verify-content h2{
            font-size: 0.2rem;
            font-weight: 500;
        }
        .verify-content h3{
            font-size: 0.32rem;
            font-weight: 500;
            margin-bottom: 0.1rem;
        }
        .verify-content h2 span{
            color: #FFE964;
            font-size: 0.32rem;
        }
        .verify-header .sub-title {
            max-width: 600px;
        }

        @media @pc{
            .work-with.mobile{
                display: none !important;
            }
        }
        @media @mobile{
            .work-with.pc{
                display: none !important;
            }
        }
        .work-with,
        .work-with a{
            font-size: 0.16rem;
            color: #fff;
            font-weight: 500;
            display: inline-block;
        }
        .work-with span{
            position: absolute;
            right: -0.2rem;
            top: 50%;
            transform: translateY(-50%);
            font-size: 0.1rem;
            transition: right .5s;
        }
        .verify-content p,
        .verify-content li{
            font-size: 0.18rem;
        }
        .verify-desc{
            margin: 0.3rem 0;
            text-align: left;
        }
        .verify-content li{
            list-style: disc;
            line-height: 1.4;
        }
        .verify-content li+li{
            margin-top: 0.15rem;
        }
        p.verify-suc{
            color: #83FC35;
            font-size: 0.22rem;
            font-weight: 500;
            text-align: center;
            position: relative;
            display: inline-block;
            padding-left: 0.4rem;
            text-align: left;
            max-width: 7rem;
        }
        p.verify-suc .icon-icon_have{
            font-size: 0.3rem;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 0;
        }
        .subscription-content{
            padding: 1rem 0;
            border-radius: 0.1rem;
            box-sizing: border-box;
            max-width: 12.7rem;
            margin: 0 auto;
            background-color: #fff;
        }
        .to-subscribe{
            padding: 1rem 0;
            background: rgba(151, 208, 255, 0.18);
            border-radius: 0.1rem;
            box-sizing: border-box;
            max-width: 12.7rem;
            margin: 0 auto;
        }
        .subscription-content p{
            margin-bottom: 0.2rem;
            font-size: 0.16rem;
        }
        p.verify-status{
            margin-bottom: 0.1rem;
            font-size: 0.2rem;
            font-weight: 500;
        }
        .verify-button{
            color: @theme;
            font-weight: 500;
            cursor: pointer;
            text-decoration: underline;
            position: relative;
            font-size: 0.18rem;
        }
        .verify-button:hover{
            text-decoration: none;
        }
        .verify-button:before{
            content: '*';
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            left: -12px;
        }
        .country-select-spinner,
        .product-select-spinner {
            max-width: 8.5rem;
            margin: 0 auto;
            .input-clue {
                margin-bottom: 0.12rem !important;
            }
        }
        .choose-plan{
            text-align: left;
            max-width: 8.5rem;
            box-sizing: border-box;
            margin: 0.3rem auto 0.6rem;
        }
        p.choose-plan-title{
            margin-bottom: 0.12rem;
        }
        .plan-statement{
            padding-left: 0.3rem;
            position: relative;
            margin-bottom: 0.6rem;
        }
        .plan-statement a{
            color: @theme;
            font-weight: 500;
        }
        .plan-statement a:hover{
            text-decoration: underline;
        }
        .plan-statement-check{
            position: absolute;
            top: 0;
            left: 0;
        }
        p.email-tip{
            font-size: 0.16rem;
            margin-bottom: 0;
        }
        p.email-tip a{
            color: @theme;
        }
        .verify-status-inner{
            margin-left: 0.2rem;
        }
        .verify-status-inner span+span{
            margin-left: 0.1rem;
        }
        .verified.verify-status span{
            color: #65d819;
        }
        .unVerified.verify-status span{
            color: #DD4429;
        }
        .verify-status-inner span:first-child{
            position: relative;
            top: 0.02rem;
        }
        .plan-des{
            font-weight: 500;
            font-size: 0.2rem;
            line-height: 0.24rem;
            vertical-align: middle;
        }
    }

    @media screen and (max-width:1199px) {
        .cloud-no-verify{
            background-color: #fff;
            .verify-content h1{
                font-size: 0.62rem;
                margin-bottom: 0.15rem;
                line-height: 1;
            }
            .verify-button{
                font-size: 0.26rem;
            }
            .verify-content{
                padding: 0;
            }
            .verify-header-bg{
                background-image: url('~IMAGE/cloud/cloud-no-verify-bg-m.png');
                padding-top: 1.4rem;
                background-repeat: no-repeat;
                padding-bottom: 0.88rem;
            }
            .verify-header{
                text-align: center;
                background: @theme-linear-gradient;
            }
            .subscription-content,
            .to-subscribe{
                border: none;
                border-radius: 0;
                max-width: 100%;
                padding: .88rem 15px;
                box-shadow: none;
            }
            .verify-content h2{
                font-size: 0.26rem;
                padding: 0 15px;
            }
            .verify-content h2 span{
                font-size: 0.34rem;
            }
            .work-with{
                font-size: 0.26rem;
            }
            .verify-content h3{
                margin-bottom: 0.15rem;
                font-size: .36rem;
            }
            .verify-content p{
                font-size: 0.26rem;
                margin-bottom: 0.3rem;
            }
            .verify-content .sub-title{
                font-size: 0.26rem;
                margin: 0 auto;
            }
            .verify-content h3+p{
                font-size: 0.24rem;
                margin-bottom: 0.44rem;
                font-weight: 500;
            }
            .choose-plan{
                margin-top: .16rem;
            }
            p.verify-status{
                height: 0.78rem;
                line-height: 0.78rem;
                border: 1px solid #ccc;
                border-radius: 0.45rem;
                font-size: 0.3rem;
            }
            p.verify-status .verify-status-inner{
                font-size: 0.26rem;
            }
            .verify-content h4{
                font-size: 0.24rem;
                margin-bottom: 0.3rem;
            }
            .verify-content li{
                font-size: 0.26rem;
            }
            .verify-desc{
                padding: 0.44rem 0.64rem;
                margin: 0.44rem 15px;
                max-width: 100%;
                background-color: rgba(151, 208, 255, 0.18);
                border-radius: 0.1rem;
            }
            p.verify-suc{
                font-size: 0.26rem;
                max-width: 100%;
                margin: 0 0.3rem;
                padding-left: 0.6rem;
            }
            p.verify-suc .icon-icon_have{
                font-size: 0.5rem;
            }
            p.choose-plan-title{
                margin-bottom: 0.15rem;
            }
            .plan-statement{
                padding-left: calc(22px + 0.2rem);
                margin: 0.44rem 0 0.88rem;
            }
            .verify-email{
                width: 100%;
            }
            .work-with span{
                right: -.3rem;
            }
        }
    }
    .subscription-content .notice-for-free{
        margin: 0.3rem auto;
        text-align: center;
        .des{
            display: block;
            max-width: 6rem;
            margin: 0.08rem auto 0;
        }
        // @media @mobile{
        //     margin-top: -0.58rem;
        // }
    }
</style>



// WEBPACK FOOTER //
// src/view/cloud/subscribePlan.vue